import { Component } from '@angular/core';
import {AuthService} from "./authentication-shared/services/auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'produvar-paramat';
  constructor(public auth: AuthService) {

  }
}
